{
  "name": "mitp",
  "version": "2.54.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration production --output-hashing=all --aot --subresource-integrity --source-map",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "test:ci": "jest --runInBand",
    "lint": "ng lint",
    "knip": "knip",
    "audit:fix": "npm_config_yes=true npx yarn-audit-fix@10",
    "e2e": "ng e2e",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org lantia --project medinthepocket ./dist/MedInThePocket-Webapp && sentry-cli sourcemaps upload --org lantia --project medinthepocket --release=$npm_package_version ./dist/MedInThePocket-Webapp"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.1",
    "@angular/cdk": "22.2.1",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/google-maps": "22.2.1",
    "@angular/material": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/platform-browser-dynamic": "22.2.1",
    "@angular/router": "22.2.1",
    "@auth0/angular-jwt": "^5.2.0",
    "@eslint/eslintrc": "3.3.7",
    "@eslint/js": "10.0.1",
    "@mux/mux-player": "3.13.4",
    "@mux/mux-uploader": "1.5.0",
    "@sentry/angular": "11.4.0",
    "@sentry/cli": "3.8.0",
    "@tailwindcss/postcss": "4.3.3",
    "@tinymce/tinymce-angular": "9.1.1",
    "@tolgee/ngx": "6.6.0",
    "@types/mathjs": "^9.4.2",
    "ace-builds": "1.44.0",
    "angularx-qrcode": "22.0.1",
    "dom-to-image": "^2.6.0",
    "driver.js": "1.9.0",
    "echarts": "6.1.0",
    "exceljs": "^4.4.0",
    "fabric": "^7.4.0",
    "file-saver": "^2.0.5",
    "filepond": "4.32.12",
    "filepond-plugin-file-validate-size": "^2.2.8",
    "filepond-plugin-file-validate-type": "^1.2.9",
    "filepond-plugin-image-preview": "^4.6.12",
    "filepond-plugin-image-resize": "^2.0.10",
    "filepond-plugin-media-preview": "^1.0.11",
    "firebase": "12.19.0",
    "flag-icons": "7.5.0",
    "flyonui": "^2.4.1",
    "fuse.js": "7.5.0",
    "fuzzball": "2.2.6",
    "help": "^3.0.2",
    "html2canvas": "^1.4.1",
    "mammoth": "1.13.0",
    "marked": "18.0.14",
    "material-design-icons": "^3.0.1",
    "mathjs": "15.2.0",
    "mathlive": "0.111.0",
    "mermaid": "12.1.0",
    "ng2-pdf-viewer": "10.4.0",
    "ngx-countdown": "22.0.0",
    "ngx-echarts": "22.0.0",
    "ngx-filepond": "^7.0.3",
    "ngx-mask": "22.2.1",
    "ngx-pipes": "^3.2.2",
    "pdfjs-dist": "6.4.299",
    "rxjs": "7.8.2",
    "sequential-workflow-designer": "0.40.4",
    "sequential-workflow-designer-angular": "0.40.4",
    "tinymce": "8.9.2",
    "tslib": "2.8.1",
    "zone.js": "0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.1",
    "@angular-eslint/builder": "22.5.0",
    "@angular-eslint/eslint-plugin": "22.5.0",
    "@angular-eslint/eslint-plugin-template": "22.5.0",
    "@angular-eslint/schematics": "22.5.0",
    "@angular-eslint/template-parser": "22.5.0",
    "@angular/build": "22.2.1",
    "@angular/cli": "22.2.1",
    "@angular/compiler-cli": "22.2.1",
    "@playwright/test": "1.63.0",
    "@types/dom-to-image": "^2.6.7",
    "@types/file-saver": "^2.0.7",
    "@types/googlemaps": "^3.43.3",
    "@types/jest": "30.0.0",
    "@types/node": "26.6.4",
    "@typescript-eslint/eslint-plugin": "8.71.0",
    "@typescript-eslint/parser": "8.71.0",
    "angular-eslint": "22.5.0",
    "autoprefixer": "10.6.1",
    "eslint": "10.12.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.6",
    "jest": "30.5.2",
    "jest-environment-jsdom": "30.5.2",
    "jest-preset-angular": "17.0.1",
    "knip": "6.39.0",
    "license-compliance": "4.0.0",
    "postcss": "8.5.28",
    "prettier": "3.9.9",
    "prettier-eslint": "17.1.2",
    "prettier-plugin-tailwindcss": "0.8.1",
    "tailwindcss": "4.3.3",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "8.71.0"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
